import { render, staticRenderFns } from "./DinnerIvrCallDetails.vue?vue&type=template&id=118c1497&"
import script from "./DinnerIvrCallDetails.vue?vue&type=script&lang=js&"
export * from "./DinnerIvrCallDetails.vue?vue&type=script&lang=js&"
import style0 from "./DinnerIvrCallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports